import { useEffect } from 'react';

import validate from './ClubStaffEditFormValidation';

import { COACH_ORG_ROLE_FIELD_NAME } from '../../../../utils/ClubConstants';

import useOrgRoleStaffRoleHierarchyData from '@usas/ui-web/state/orgRoleStaffRoleHierarchy/UseOrgRoleStaffRoleHierarchyData';

import useForm from '@usas/ui-web/utils/UseForm';
import HierarchicalDataUtils from '@usas/ui-web/utils/HierarchicalDataUtils';

const coachTypeCodeOptions = [
  { id: 'F', name: "Full Time" },
  { id: 'P', name: "Part Time" }
];

const INITIAL_FORM_STATE = {
  coachTypeCode: coachTypeCodeOptions[0].id,
  coachTypeCodeName: coachTypeCodeOptions[0].name,
  personOrgRole: [],
  registrationRoles: [],
  hasCoachRole: false,
};

const useClubStaffEditForm = (clubStaffObj, onSubmitFormCallback, onIsDirtyChanged, onErrorCaught) => {
  const { orgRoleStaffRoleHierarchyState } = useOrgRoleStaffRoleHierarchyData();
  const { isDirty, formState, errorState, setIsDirty, handleSubmit, onValueTextPairChanged,
    setFormData, setErrors
  } = useForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  const onPersonOrgRoleChanged = (personOrgRole) => {
    try {
      const hasCoachRole = getHasCoachRole(personOrgRole);

      setFormData({
        ...formState,
        personOrgRole,
        hasCoachRole
      });
      setIsDirty(true);
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : setErrors({ formError: e?.message });
    }
  };

  useEffect(() => {
    try {
      if (clubStaffObj && orgRoleStaffRoleHierarchyState.isArrayLoaded === true) {
        const staffRoleIds = clubStaffObj.personOrgRole.filter((x) => x.isPrimary !== true).map((x) => x.orgRoleId);
        const personOrgRole = HierarchicalDataUtils.GetNameIdPairs(orgRoleStaffRoleHierarchyState.treeDataNoRegistrationRolesWithoutChildren, staffRoleIds);
        const registrationRoles = clubStaffObj.personOrgRole.filter((x) => x.isPrimary === true).map((x) => { return { id: x.orgRoleId, name: x.orgRoleName } });
        let coachOrgRoleFieldValue = undefined;
        
        for (const role of clubStaffObj.personOrgRole) {
          const coachOrgRoleField = role.personOrgRoleFields.find(x => x.fieldName === COACH_ORG_ROLE_FIELD_NAME);
          
          if (coachOrgRoleField) {
            coachOrgRoleFieldValue = coachOrgRoleField.fieldValue;
            break;
          }
        }

        setFormData({
          ...INITIAL_FORM_STATE,
          personOrgRole,
          registrationRoles,
          coachTypeCode: coachOrgRoleFieldValue || coachTypeCodeOptions[0].id,
          coachTypeCodeName: coachOrgRoleFieldValue ? coachTypeCodeOptions.find(x => x.id === coachOrgRoleFieldValue).name : coachTypeCodeOptions[0].name,
          hasCoachRole: getHasCoachRole(personOrgRole),
        });
      }
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : setErrors({ formError: e?.message });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubStaffObj, orgRoleStaffRoleHierarchyState]);

  useEffect(() => {
    try {
      if (onIsDirtyChanged) {
        onIsDirtyChanged(isDirty);
      }
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : setErrors({ formError: e?.message });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirty]);

  function getHasCoachRole(personOrgRole) {
    for (const role of personOrgRole) {
      const targetRole = HierarchicalDataUtils.FindNodeById(role.id, orgRoleStaffRoleHierarchyState.arrayData);

      if (Array.isArray(targetRole?.orgRoleField) && targetRole.orgRoleField.some(x => x.fieldName === COACH_ORG_ROLE_FIELD_NAME)) {
        return true;
      }
    }

    return false;
  }

  return {
    isDirty,
    formState,
    errorState,
    handleSubmit,
    onValueTextPairChanged,
    onPersonOrgRoleChanged,
    coachTypeCodeOptions
  };
};

export default useClubStaffEditForm;